import { request } from "http";
import { Ifilter } from "../../Interfaces/filter";
import { ICatalogoInseguro, ICatalogoOculto, ICrearCatalogo, IEditCatalogo } from "../../Interfaces/hazard/IHazard";
import { fetchListVerificacion } from "../http-common";

const CatalogoInseguro = "CatalogoInseguro";

const ComboCatalogoInseguro = (request: ICatalogoInseguro, controller = new AbortController()) => {
    return fetchListVerificacion.get(`${CatalogoInseguro}/Combo`, {
        params: request,
        signal: controller.signal,
    });
};
const CatalogoList=(request:ICatalogoInseguro)=>{
    return fetchListVerificacion.post(`${CatalogoInseguro}/ListarCatalogo`,request)
}
const CrearCatalogo=(request:ICrearCatalogo)=>{
    return fetchListVerificacion.post(`${CatalogoInseguro}/CrearCatalogo`,request)
}
const ActualizarCatalogo=(request:IEditCatalogo)=>{
    return fetchListVerificacion.put(`${CatalogoInseguro}/ActualizarCatalogo`,request)
}
const OcultarCatalogo=(request:ICatalogoOculto)=>{
    return fetchListVerificacion.put(`${CatalogoInseguro}/OcultarCatalogo`,request)
}
const CatalogoInseguroService = {
    ComboCatalogoInseguro,CatalogoList,CrearCatalogo,ActualizarCatalogo,OcultarCatalogo
}

export { CatalogoInseguroService };